export enum ROUTE_HOME {
  LANDING = 'index',
  HOME = 'home',
  HOME_FAVORITES = 'home-favorites',

  LANDING_WIDGET_PROFILE = 'index-widget-profile',
  LANDING_WIDGET_CONTENT_READER = 'index-widget-content-reader',
}
